import type { IFileMetadataEntry } from './files-details.utils'

export const FileMetadataGrid = ({ entries }: { entries: IFileMetadataEntry[] }) => {
  if (entries.length === 0) {
    return <p className="text-sm text-muted-foreground">No extracted details available yet.</p>
  }

  return (
    <div className="grid gap-3 md:grid-cols-2">
      {entries.map((entry) => (
        <div key={`${entry.label}-${entry.value}`} className="rounded-xl border bg-background px-4 py-3">
          <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-muted-foreground">{entry.label}</p>
          <p title={entry.value} className="mt-1 break-words text-sm font-medium">
            {entry.value}
          </p>
        </div>
      ))}
    </div>
  )
}
